<div class="w-full flex flex-col">
    <div class="flex flex-col">
        <span class="font-semibold text-2xl py-2">
            Actualizar Departamento / Municipio
        </span>
   </div>

    <form #myForm="ngForm" class="flex flex-col w-full">
        <mat-form-field class="fuse-mat-dense flex-1">
            <mat-label>Departamento</mat-label>
            <input
                matInput
                placeholder="Buscar departamento"
                [(ngModel)]="departamentoActual"
                name="departamento"
                id="departamento"
                [matAutocomplete]="auto"
                (input)="filterDepartamento$.next($event.target.value)"
            />

            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnDepartamento"
            (optionSelected)="getMunicipios($event.option.value)">
                <mat-option *ngFor="let d of departamentos$ | async" [value]="d">
                {{ d.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>


        <mat-form-field class="fuse-mat-dense flex-1">
            <mat-label>Municipio</mat-label>
            <input type="text" #municipioInput
                    matInput
                    placeholder="Buscar Municipio"
                    [(ngModel)]="municipioActual" id="municipio"
                    name="municipio"
                    id="municipio"
                    [matAutocomplete]="autoMunicipio"
                    (input)="filterMunicipios$.next($event.target.value)"
                    />

            <mat-autocomplete
                #autoMunicipio="matAutocomplete" 
                [displayWith]="displayFnMunicipio">
                <mat-option *ngFor="let m of municipios$ | async" [value]="m">
                {{ m.descripcion }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <buscador-gestiones
            [tiposGestionesBienesCulturales]="listaGestiones"
            (gestionesSeleccionadasChange)="gestionesSeleccionadasPadre = $event"
            ></buscador-gestiones>

        <mat-checkbox 
            class="mt-4"
            name="cambioNoRegistro" id="cambioNoRegistro"
                [(ngModel)]="cambioNoRegistro">
            ¿Desea cambiar el número de registro del bien cultural?
        </mat-checkbox>
    </form>
    

    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-raised-button
            class="rounded-sm w-full"  
            [color]="'secondary'"
            (click)="this.dialogRef.close(false)">
            Cancelar
        </button>

        <button mat-raised-button 
            [color]="'primary'" 
            class="rounded-sm w-full"
            type="submit"
            (click)="postActualizacion()"
            [disabled]="!myForm.valid || gestionesSeleccionadasPadre.length === 0"
            >Actualizar
        </button>
    </div>
</div>